import TrackerTable from "./components/emailTrack-table/trackerTable";

const TrackerTables = () => {
  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <TrackerTable />
      </div>
    </div>
  );
};

export default TrackerTables;
